export default "__VITE_ASSET__ff004c5c__"